module.exports = __webpack_public_path__ + "static/media/rank2.ffe87507.svg";